<template>
  <div class="about-video-gallery">
    <div class="about-video-gallery-bg"></div>
    <div class="about-video-gallery-content-wrapper">
      <h3 class="text-accent">{{ $t('about-video-gallery-1') }}</h3>
      <div class="about-video-gallery-content">
        <div class="about-video-wrapper">
          <transition name="fade" mode="out-in">
            <video
              controls="controls"
              autoplay
              muted
              @ended="rePositionVideos(1)"
              :key="videos[0].src"
              ref="currentVideo"
              @timeupdate="updateProgress()"
            >
              <source :src="videos[0].src" :key="'v' + videos" type="video/mp4">Your browser does not support HTML5 video.
            </video>
          </transition>
        </div>
        <div class="about-video-list-wrapper">
          <h3 class="strong text-light">{{ $t('about-video-gallery-2') }}</h3>
          <div class="about-video-list" ref="videoList">
            <div
              class="about-video-list-item"
              :class="{ 'about-video-list-item-active': i === 0 }"
              v-for="(v, i) in videos"
              :key="`toggle-video-${i}`"
              @click="rePositionVideos(i)"
              :ref="`galeryVideo${i}`"
            >
              <img :src="v.thumb">
              <div class="text-group">
                <p class="medium text-light">{{ $t(v.title) }}</p>
                <!-- <p class="text-light">{{ $t(v.text) }}</p> -->
              </div>
              <div class="video-progress" v-if="i === 0" :style="{ width: `${progress}%`}"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      progress: 0,
      videos: [
        {
          src: require('../../assets/video/about/pb.mp4'),
          thumb: require('../../assets/video/about/pb.jpg'),
          title: 'about-video-gallery-3',
          // text: 'about-video-gallery-4'
        },
        {
          src: require('../../assets/video/about/zn.mp4'),
          thumb: require('../../assets/video/about/zn.jpg'),
          title: 'about-video-gallery-7',
          // text: 'about-video-gallery-8'
        },
        {
          src: require('../../assets/video/about/au.mp4'),
          thumb: require('../../assets/video/about/au.jpg'),
          title: 'about-video-gallery-13',
          // text: 'about-video-gallery-14'
        },
        {
          src: require('../../assets/video/about/ag.mp4'),
          thumb: require('../../assets/video/about/ag.jpg'),
          title: 'about-video-gallery-15',
          // text: 'about-video-gallery-16'
        }
      ]
    };
  },
  methods: {
    rePositionVideos(n) {
      if (n !== 0) {
        this.videos = this.videos.slice(n).concat(this.videos.slice(0, n));
      }
      this.$refs.videoList.scrollTop = 0;
    },
    updateProgress() {
      if (this.$refs.currentVideo) {
        this.progress =
          (this.$refs.currentVideo.currentTime * 100) /
            this.$refs.currentVideo.duration || 0;
      } else {
        this.progress = 0;
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.about-video-gallery {
  background-color: $bgColor1;
  margin: 30px 0;
  position: relative;
  width: 100%;
  .about-video-gallery-bg {
    background-image: url('../../assets/img/about/video_gallery_bg.jpg');
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    left: 0;
    opacity: 0.2;
    position: absolute;
    top: 0;
    width: 100%;
  }
  .about-video-gallery-content-wrapper {
    @extend %flex-center;
    height: 100%;
    padding: 0 10% 80px;
    flex-direction: column;
    position: relative;
    z-index: 1;
    .text-accent {
      @extend %flex-center;
      height: 80px;
      text-align: center;
    }
    .about-video-gallery-content {
      @extend %flex-center;
      align-items: stretch;
      background-color: rgba(255, 255, 255, 0.25);
      padding: 30px 40px;
      width: 100%;
      .about-video-wrapper {
        background-color: rgba(255, 255, 255, 0.25);
        width: 65%;
        video {
          display: block;
          height: 28vw;
          outline: none;
          width: 100%;
        }
      }
      .about-video-list-wrapper {
        background-color: rgba(255, 255, 255, 0.25);
        margin-left: 20px;
        width: calc(35% - 20px);
        h3 {
          @extend %flex-center;
          height: 40px;
          text-align: center;
        }
        .about-video-list {
          display: flex;
          flex-direction: column;
          overflow: auto;
          height: calc(28vw - 40px);
          padding: 0 20px 20px;
          .about-video-list-item {
            cursor: pointer;
            display: flex;
            height: 80px;
            min-height: 80px;
            margin-bottom: 10px;
            position: relative;
            @include transition(all 0.3s);
            img {
              box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);
              display: block;
              height: 80px;
              min-height: 80px;
              min-width: 150px;
              width: 150px;
            }
            .text-group {
              padding-left: 20px;
              padding-right: 10px;
              p {
                font-size: 12px;
                margin: 0;
              }
              .medium {
                font-size: 18px;
                margin: 15px 0;
              }
            }
            .video-progress {
              background-color: $accentColor;
              bottom: 0;
              height: 4px;
              left: 0;
              position: absolute;
              @include transition(all 0.2s);
              width: 0;
            }
          }
          .about-video-list-item:hover,
          .about-video-list-item-active {
            background-color: rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }
}
.about-video-gallery::before,
.about-video-gallery::after {
  background-color: $accentColor;
  content: '';
  height: 30px;
  right: 50%;
  top: -30px;
  position: absolute;
  width: 17.5%;
}
.about-video-gallery::after {
  top: 100%;
}
@media screen and (max-width: 1900px) {
  .about-video-gallery {
    .about-video-gallery-content-wrapper {
      .about-video-gallery-content {
        .about-video-list-wrapper {
          .about-video-list {
            .about-video-list-item {
              .text-group {
                p {
                  font-size: 12px;
                  line-height: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .about-video-gallery {
    .about-video-gallery-content-wrapper {
      .about-video-gallery-content {
        .about-video-wrapper {
          width: 60%;
          video {
            height: 25vw;
          }
        }
        .about-video-list-wrapper {
          width: calc(40% - 20px);
          .about-video-list {
            height: calc(25vw - 40px);
            .about-video-list-item {
              .text-group {
                .medium {
                  font-size: 18px;
                }
                p {
                  font-size: 11px;
                  line-height: 15px;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .about-video-gallery {
    .about-video-gallery-content-wrapper {
      padding: 0 $sidesPadding1280 $sidesPadding1280;
      .about-video-gallery-content {
        .about-video-wrapper {
          video {
            height: 30vw;
          }
        }
        .about-video-list-wrapper {
          .about-video-list {
            height: calc(30vw - 40px);
            .about-video-list-item {
              .text-group {
                .medium {
                  font-size: 14px;
                }
                p {
                  font-size: 10px;
                  line-height: 14px;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .about-video-gallery {
    margin: 15px 0;
    .about-video-gallery-content-wrapper {
      padding: 0 $sidesPadding1280 $sidesPadding1280;
      .about-video-gallery-content {
        .about-video-wrapper {
          width: 100%;
          video {
            display: block;
            height: auto;
          }
        }
        .about-video-list-wrapper {
          display: none;
        }
      }
    }
  }
  .about-video-gallery::before,
  .about-video-gallery::after {
    width: 50%;
    right: 25%;
    height: 15px;
  }
  .about-video-gallery::before {
    top: -15px;
  }
}
@media screen and (max-width: 600px) {
  .about-video-gallery {
    .about-video-gallery-content-wrapper {
      padding: 0 $sidesPadding600;
      padding-bottom: $sidesPadding600 * 2;
      .text-accent {
        height: 60px;
      }
      .about-video-gallery-content {
        padding: $sidesPadding600;
      }
    }
  }
}
</style>
